module.exports = __webpack_public_path__ + "img/md_samsung.393c9e47.png";